// extracted by mini-css-extract-plugin
export default {"container":"badges_container__49erW","icon":"badges_icon__y0-Tk"};